<template>
  <div class="field">
    <label class="label">
      {{label}}
      <b-icon pack="fas" icon="star" class="fa-ss" v-show="required"></b-icon>
    </label>
    <div class="control is-flex">
      <multiselect @select="$markDirty()"
      :showLabels="false"
      :name="instanceName"
      :taggable="true"
      @tag="insurerAdded"
      tagPlaceholder="Press enter to create a new insurer"
      tagPosition="bottom"
      :searchable="true"
      data-vv-validate-on="input|close"
      :data-vv-as="this.validateAs"
      v-validate="{'required': required}"
      :class="{'is-danger': errors.has(validationName) }"
      v-model="selectedInsurer"
      :options="allInsurers"
      label="name"
      :disabled="isDisabled"
      trackBy="id"
      :loading="isInsurerLoading"
      placeholder="Type to search for a insurer"
      :internal-search="false"
      :options-limit="300"
      @search-change="onInsurerSearch"
      :data-vv-scope="scope"
      :hideSelected="true"></multiselect>
      <a class="button is-primary new-insurer-btn" @click="isNewInsurerActive = true" v-if="allowNew && showNewAction">
        <span class="icon">
          <i class="fas fa-plus"></i>
        </span>
      </a>
    </div>
    <span v-show="errors.has(validationName)" class="help is-danger"><i v-show="errors.has(validationName)" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName) }}</span>
    <b-modal :active.sync="isNewInsurerActive" scroll="keep" :width="500" :has-modal-card="true">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title"><portal-target name="modal-header" slim/></p>
        </header>
        <section class="modal-card-body" style="min-width:400px !important; height:250px;">
          <new-insurer
            mode="modal"
            actionPortal="modal-footer"
            headerPortal="modal-header"
            v-on:on-save="onInsurerSaved"
            v-on:on-cancel="onInsurerCancelled"
            :startWith="nameOfInsurerToCreate">
          </new-insurer>
        </section>
        <footer class="modal-card-foot">
          <portal-target name="modal-footer" class="actions" slim/>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>

import _ from 'lodash'
import NewInsurer from '@/components/configuration/insurers/NewInsurer'
import insurerService from '@/services/insurerService'

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'InsurerSelector',
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Insurer'
    },
    validateAs: {
      type: String,
      default: 'Insurer'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    selectedDealer: {
      type: Object,
      default: null
    },
    allowNew: {
      type: Boolean,
      default: true
    },
    showNewAction: {
      type: Boolean,
      default: false
    },
    scope: {
      type: String,
      default: null
    }
  },
  components: {
    'new-insurer': NewInsurer
  },
  data () {
    return {
      isInsurerLoading: false,
      isNewInsurerActive: false,
      selectedInsurer: this.value,
      nameOfInsurerToCreate: '',
      data: [],
      instanceName: 'insurer-selector-' + this.$uuid.v4(),
      storeDealer: this.$store.state.dealer.currentDealer
    }
  },
  computed: {
    allInsurers () {
      return this.data
    },
    validationName: function () {
      return this.scope ? this.scope + '.' + this.instanceName : this.instanceName
    }
  },
  watch: {
    selectedInsurer: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value: function (newValue, oldValue) {
      this.selectedInsurer = newValue
      if (newValue) {
        this.data.push(newValue)
      }
    },
    selectedDealer: function (newValue, oldValue) {
      this.selectedDealer = newValue
      // Only reset the insurer on dealer change if its not the same dealer as the insurer already belongs to
      if (this.selectedInsurer && this.selectedInsurer.dealerId !== this.selectedDealer.id) {
        this.selectedInsurer = null
      }
    },
    storeDealer: function (newValue, oldValue) {
      this.selectedDealer = newValue
    }
  },
  methods: {
    insurerAdded: function (data) {
      if (this.allowNew) {
        this.nameOfInsurerToCreate = data
        this.isNewInsurerActive = true
      }
    },
    onInsurerSaved: function (newInsurer) {
      this.data.push(newInsurer)
      this.selectedInsurer = newInsurer
      this.isNewInsurerActive = false
    },
    onInsurerCancelled: function () {
      this.isNewInsurerActive = false
    },
    clearAllInsurers () {
      this.data = []
    },
    loadAsyncData: function (query) {
      var searchCommand = {
        page: 0,
        pageSize: 100,
        query: query,
        dealerId: this.selectedDealer.id,
        sortBy: 'name.asc'
      }
      this.isInsurerLoading = true
      this.clearAllInsurers()
      insurerService.all(searchCommand).then(response => {
        this.data = response.results
        this.isInsurerLoading = false
      })
    },
    doInsurerSearch: _.debounce(function (query) { this.loadAsyncData(query) }, 500),
    onInsurerSearch (query) {
      this.doInsurerSearch(query)
    }
  }
}

</script>

<style scoped>
  .new-insurer-btn {
    margin-left:5px;
    height:40px;
  }

  .modal-card-body {
    overflow:auto;
    height: calc(100vh - 185px);
  }
</style>
